// src/config.js
// export const API_BASE_URL = 'http://192.168.219.45:5050';
//export const API_BASE_URL = 'http://106.249.152.207:5050';
//export const API_BASE_URL = 'https://106.249.152.207:5050';
//export const API_BASE_URL = 'http://sndsolution.duckdns.org';
export const API_BASE_URL = 'https://www.sndone.co.kr';
